"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.default=void 0;/**
 * @module radspec/helpers/HelperManager
 */ /**
 * Class for managing the execution of helper functions
 *
 * @class HelperManager
 * @param {Object} availableHelpers Defined helpers
 */class HelperManager{constructor(){let availableHelpers=0<arguments.length&&arguments[0]!==void 0?arguments[0]:{};this.availableHelpers=availableHelpers}/**
   * Does a helper exist
   *
   * @param  {string} helper Helper name
   * @return {bool}
   */exists(helper){return!!this.availableHelpers[helper]}/**
   * Execute a helper with some inputs
   *
   * @param  {string} helper Helper name
   * @param  {Array<radspec/evaluator/TypedValue>} inputs
   * @param  {Object} config Configuration for running helper
   * @param  {ethersProvider.Provider} config.provider Current provider
   * @param  {radspec/evaluator/Evaluator} config.evaluator Current evaluator
   * @param  {Object} config.functions Current function signatures
   * @return {Promise<radspec/evaluator/TypedValue>}
   */execute(helper,inputs,_ref){let{provider,evaluator,functions}=_ref;// pass values directly
return inputs=inputs.map(input=>input.value),this.availableHelpers[helper](provider,evaluator,functions)(...inputs)}/**
   * Get all registered helpers as a key-value mapping
   *
   * @return {Object}
   */getHelpers(){return this.availableHelpers}}exports.default=HelperManager;
